import { CloseOutlined } from "@ant-design/icons"
import { Form, FormInstance, FormProps, Input, Modal } from "antd"
import { useEffect, useRef } from "react"
import './style.scss'
import { addCarLines } from "../../../../../api/carLine/carLineApi"
import { useForm } from "antd/lib/form/Form"
interface ModalProps {
  isOpen: boolean
  onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
  closeModal: (isshow: boolean) => void
}
const ModalCreateVehicle: React.FC<ModalProps> = ({
  isOpen,
  onSubmitFormModal, closeModal
}) => {

  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    const { code, title } = values

    const result = await addCarLines(code, title)
    if (result?.data) {
      onSubmitFormModal?.(true, result.message)
    } else {
      onSubmitFormModal?.(false, result.message)
    }
  }

  useEffect(() => {
    if (isOpen) {

    } else {
      form.resetFields()
    }
  }, [isOpen])

  return (
    <Form
      className="form-add-vehicle"
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Tạo mới dòng xe</span>
          <CloseOutlined
            className="text-base text-8B8B8B"
            onClick={() => closeModal(false)}
          />
        </div>}
        open={isOpen}
        onCancel={() => closeModal(false)}
        centered
        className="w-modal modal-content-vehicle ant-modal-size"
        closeIcon={false}
        footer={
          <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
            <span className="text-sm text-98A2B3 cursor-pointer"
              onClick={() => closeModal(false)}
            >Huỷ</span>
            <button
              className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
              onClick={submitForm}>
              Lưu
            </button>
          </div>}
      >
        <div className="p-6 d-flex flex-column gap-18-px">

          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <div className="d-flex flex-column gap-1">
                <Form.Item
                  label={<span className="">Mã dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                  layout="vertical"
                  name="code"
                  rules={[{ required: true, message: 'Nhập mã dòng xe!' }]}
                  className="m-none-form-item text-explan text-label"
                >
                  <Input
                    placeholder="Mã dòng xe"
                    className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="title"
                rules={[{ required: true, message: 'Nhập dòng xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Dòng xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
        </div>

      </Modal>
    </Form>

  )
}
export default ModalCreateVehicle
